import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { BackupDialogData } from '@app/shared/components/dialogs/backup-dialog/backup-dialog.data';

@Component({
    selector : 'backup-dialog',
    template: require('./backup-dialog.component.html'),
    styles: [require('./backup-dialog.component.scss')]
})
export class BackupDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: BackupDialogData) {
    }

    public isBackupSelected: boolean = false;

    public onSelect() {
        this.isBackupSelected = true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/backup-dialog/backup-dialog.component.ts